module.exports = __webpack_public_path__ + "assets/certificate_pdf/Data Analysis Using Excel_Silicon Stone Education_2019-10-05.62407fc8.pdf";